import { NickNamer } from "nicknames-curated";

const nicknames = new NickNamer();

/** Whether the curated list relates the two given names directly, in either direction. */
export function areDirectNicknames(left: string, right: string): boolean {
  return nicknames.nicknamesOf(left).has(right) || nicknames.nicknamesOf(right).has(left);
}

/**
 * Given names the curated list relates directly to `name`: its nicknames and the names it is a nickname of.
 * Never transitive, so Bill relates to William but not, through William, to Will.
 */
export function directlyRelatedGivenNames(name: string): string[] {
  return [...new Set([...nicknames.nicknamesOf(name), ...nicknames.canonicalsOf(name)])];
}
